import { render } from "./Venue.vue?vue&type=template&id=875fbf60&scoped=true"
import script from "./Venue.vue?vue&type=script&lang=js"
export * from "./Venue.vue?vue&type=script&lang=js"

import "./Venue.vue?vue&type=style&index=0&id=875fbf60&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-875fbf60"

export default script